import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx"
import GridItem from "../../../components/Grid/GridItem.jsx"

import productStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx"

class MarketingSection extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <div>
                <div>
                    <div
                        className={classes.marketingSection}
                        style={{
                            backgroundImage: "url(" + require("../../../assets/img/line-cook.jpg") + ")",
                            marginBottom: "6rem",
                            backgroundPositionX: "50%",
                            backgroundPositionY: "50%",
                            position: "relative",
                            backgroundSize: "cover",
                        }}>
                        <div
                            style={{
                                position: "absolute",
                                opacity: "0.7",
                                content: "",
                                background: "#252525",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0,
                                zIndex: 1,
                            }}
                        />
                        <GridContainer style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <GridItem xs={12} sm={12} lg={1} style={{ textAlign: "center" }} />

                            <GridItem
                                xs={12}
                                sm={12}
                                lg={3}
                                style={{
                                    textAlign: "center",
                                    padding: "2rem",
                                    backgroundColor: "rgba(20, 20, 20, 0.3)",
                                    zIndex: 3,
                                    margin: "1rem",
                                }}>
                                <div
                                    className={classes.marketingBoxTitle}
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "1.5rem",
                                    }}>
                                    <div>
                                        <i className="material-icons" style={{ fontSize: "2.5rem" }}>
                                            payment
                                        </i>
                                    </div>
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "1.3rem",
                                        }}>
                                        {" "}
                                        Get started
                                    </span>
                                </div>
                                <div className={classes.marketingBoxDescription}>
                                    Sign up today to begin.
                                    <br />
                                    Enter your email address below or speak to our sales team at
                                    <a href="tel:+18555344873" style={{ color: "#fff" }}>
                                        {" "}
                                        +1 (855) 534-4873
                                    </a>
                                </div>
                            </GridItem>

                            <GridItem
                                xs={12}
                                sm={12}
                                lg={3}
                                style={{
                                    textAlign: "center",
                                    padding: "2rem",
                                    backgroundColor: "rgba(20, 20, 20, 0.3)",
                                    zIndex: 3,
                                    margin: "1rem",
                                }}>
                                <div
                                    className={classes.marketingBoxTitle}
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "1.5rem",
                                    }}>
                                    <div>
                                        <i className="material-icons" style={{ fontSize: "2.5rem" }}>
                                            highlight
                                        </i>
                                    </div>
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "1.3rem",
                                        }}>
                                        {" "}
                                        Launching
                                    </span>
                                </div>
                                <div className={classes.marketingBoxDescription}>
                                    Send us your menu, logo and images - we will take care of the rest. Increase revenue from online and mobile orders.
                                </div>
                            </GridItem>

                            <GridItem
                                xs={12}
                                sm={12}
                                lg={3}
                                style={{
                                    textAlign: "center",
                                    padding: "2rem",
                                    backgroundColor: "rgba(20, 20, 20, 0.3)",
                                    zIndex: 3,
                                    margin: "1rem",
                                }}>
                                <div
                                    className={classes.marketingBoxTitle}
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "1.5rem",
                                    }}>
                                    <div>
                                        <i className="material-icons" style={{ fontSize: "2.5rem" }}>
                                            insert_chart_outlined
                                        </i>
                                    </div>
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "1.3rem",
                                        }}>
                                        {" "}
                                        Fuel Growth
                                    </span>
                                </div>
                                <div className={classes.marketingBoxDescription}>
                                    Watch your business grow to greater heights. Raise your revenue, increase your
                                    profits and elevate customer satisfaction!
                                </div>
                            </GridItem>

                            <GridItem xs={12} sm={12} lg={1} style={{ textAlign: "left" }} />
                        </GridContainer>
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(productStyle)(MarketingSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/MarketingSection.jsx